// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__DhF1P","large":"styles_large__1V3x0"};